import { CardStatus, getCardStatus } from "../types/card";

export const isCardStatusActivationRequired = (status: string): boolean => {
  return getCardStatus(status) === CardStatus.ACTIVATION_REQUIRED;
};

export const isCardStatusActive = (status: string): boolean => {
  return getCardStatus(status) === CardStatus.ACTIVE;
};
